<template>
  <div class="b-join">
    <form class="b-join__form" ref="form" v-if="!successMessage" @submit.prevent="validateBeforeSubmit">
      <div class="b-join__label">Get updates</div>
      <div class="visible-xs-block clearfix"></div>
      <input class="b-join__input form-control" type="text" placeholder="First name"
        v-model="name"
        name="FNAME"
      >
      <div class="visible-xs-block clearfix"></div>
      <input class="b-join__input -email form-control" type="text" placeholder="Email address"
        v-model="email"
        name="EMAIL"
        v-validate="'required|email'"
        data-vv-name="email"
        data-vv-validate-on="blur"
        :class="{ '-error': errors.has('email') }"
      >
      <div class="visible-xs-block clearfix"></div>
      <button type="submit" class="b-join__btn">Join</button>
    </form>
    <div v-if="!errorMessage && !successMessage && errors.has('email')" transition="fade" class="b-join__message -error">{{ errors.first('email') }}</div>
    <div v-if="errorMessage && !successMessage" transition="fade" class="b-join__message -error">{{ errorMessage }}</div>
    <div v-if="successMessage" transition="fade" class="b-join__message -success">{{ successMessage }}</div>
  </div>
</template>
<script>
import Vue from 'vue';
import $ from 'jquery';

export default Vue.extend({

  props: {
    action: {
      required: true,
      type: String
    },
  },

  data () {
    return {
      email: '',
      name: '',
      response: {},
      errorMessage: null,
      successMessage: null,
    }
  },

  mounted() {
    this.$nextTick(function () {
      // code that assumes this.$el is in-document
    })
  },

  computed: {
    preparedAction () {
      return this.action.replace('/post?', '/post-json?').concat('&c=?')
    }
  },

  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(success => {
        success && this.subscribe()
      });
    },
    subscribe() {
      let params = $(this.$refs.form).serialize();

      console.log('SUBSCR', params);

      $.ajax({
        type: 'POST',
        url: this.preparedAction,
        data: params,
        dataType: 'jsonp',
        success: (res) => {
          if (res.result == 'success') {
            this.successMessage = res.msg
          } else {
            this.errorMessage = res.msg

            // Mailchimp returns error messages prefixed with numbers (ie "0 - Message"), so we'll
            // strip that out for the end user.
            this.errorMessage = this.errorMessage.substring(this.errorMessage.indexOf('-')+1, this.errorMessage.length)
          }
        }
      });
    }
  }

});
</script>



// WEBPACK FOOTER //
// Mailchimp.vue?45efd7cf